import { MAIL_VIEWS } from "../../../../constants.js";
import { MailAction, MailMessageForm } from "../../../../components/MailMessageForm/index.js";
import { useMailMessageProvider } from "../../../hooks/useMailMessageProvider.js";
import { MailMessageThread } from "../../../../components/MailMessageThread/index.js";
import { useEffect, useMemo, useRef } from "react";
import { Button, ButtonGroup, Icon, Loading, Modal, Tooltip } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdDeleteForever, MdForward, MdMarkAsUnread } from "react-icons/md";
import { BsReplyAllFill, BsReplyFill } from "react-icons/bs";
import { HiFlag } from "react-icons/hi2";
// src/modules/Mail/screens/MailScreen/components/MailMessageDisplayModal/index.tsx
var MailMessageDisplayModal = ({ closeHandler, mailMessageId, onDeleteMessage }) => {
	const { deleteMessage, deletingMessage, flagMessage, linkedMessages, loadingMessage: loading, loadingThreadData, mailAction, mailMessage, readMessage, responseData, setMailAction, threadData, updatingFlagged, updatingUserRead } = useMailMessageProvider({ mailMessageId });
	const actionRef = useRef(null);
	const threadMessagesIds = useMemo(() => {
		return threadData?.mailMessages.map((message) => message.id) || [];
	}, [threadData]);
	useEffect(() => {
		if (mailAction && actionRef.current) actionRef.current.scrollIntoView({ behavior: "smooth" });
	}, [mailAction]);
	if ((loading || loadingThreadData) && !threadData) return /* @__PURE__ */ jsx(Modal, {
		closeHandler,
		children: /* @__PURE__ */ jsx("div", {
			className: "h-72",
			children: /* @__PURE__ */ jsx(Loading, { overlay: true })
		})
	});
	if (!mailMessageId || !mailMessage || !threadData) return null;
	const { fileUrls, subject, threadId, userFlagged, userFolder, userRead } = mailMessage || {};
	return /* @__PURE__ */ jsxs(Modal, {
		closeHandler,
		showClose: false,
		children: [deletingMessage && /* @__PURE__ */ jsx(Loading, { overlay: true }), /* @__PURE__ */ jsxs("div", { children: [
			/* @__PURE__ */ jsxs("div", {
				className: "-top-base z-sticky gap-x-xs py-sm sticky flex flex-wrap-reverse items-start justify-end",
				role: "toolbar",
				children: [/* @__PURE__ */ jsx("h1", {
					className: classnames({
						"font-bold": subject,
						"text-color-subtle": !subject
					}, "truncated text-md grow"),
					children: subject || "No Subject"
				}), /* @__PURE__ */ jsxs(ButtonGroup, { children: [
					/* @__PURE__ */ jsx(Button, {
						subtle: true,
						onClick: () => {
							setMailAction(MailAction.Reply);
							if (actionRef.current) actionRef.current.scrollIntoView({ behavior: "smooth" });
						},
						children: /* @__PURE__ */ jsx(Tooltip, {
							tooltip: "Reply",
							children: /* @__PURE__ */ jsx(Icon, { Icon: BsReplyFill })
						})
					}),
					/* @__PURE__ */ jsx(Button, {
						subtle: true,
						onClick: () => {
							setMailAction(MailAction.ReplyAll);
							if (actionRef.current) actionRef.current.scrollIntoView({ behavior: "smooth" });
						},
						children: /* @__PURE__ */ jsx(Tooltip, {
							tooltip: "Reply to All",
							children: /* @__PURE__ */ jsx(Icon, { Icon: BsReplyAllFill })
						})
					}),
					/* @__PURE__ */ jsx(Button, {
						subtle: true,
						onClick: () => {
							setMailAction(MailAction.Forward);
							if (actionRef.current) actionRef.current.scrollIntoView({ behavior: "smooth" });
						},
						children: /* @__PURE__ */ jsx(Tooltip, {
							tooltip: "Forward",
							children: /* @__PURE__ */ jsx(Icon, { Icon: MdForward })
						})
					}),
					userFolder !== MAIL_VIEWS.TRASH && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Button, {
						disabled: deletingMessage,
						subtle: true,
						onClick: async () => {
							await deleteMessage();
							onDeleteMessage?.();
							closeHandler?.();
						},
						children: /* @__PURE__ */ jsx(Tooltip, {
							tooltip: "Delete",
							children: /* @__PURE__ */ jsx(Icon, { Icon: MdDeleteForever })
						})
					}), /* @__PURE__ */ jsx(Button, {
						disabled: updatingUserRead,
						subtle: true,
						onClick: readMessage,
						children: /* @__PURE__ */ jsx(Tooltip, {
							tooltip: "Mark as Unread",
							children: /* @__PURE__ */ jsx(Icon, {
								color: !userRead && !updatingUserRead ? "main" : "",
								Icon: MdMarkAsUnread
							})
						})
					})] }),
					/* @__PURE__ */ jsx(Button, {
						disabled: updatingFlagged,
						subtle: true,
						onClick: flagMessage,
						children: /* @__PURE__ */ jsx(Tooltip, {
							tooltip: "Flag",
							children: /* @__PURE__ */ jsx(Icon, {
								color: userFlagged && !updatingFlagged ? "caution" : "",
								Icon: HiFlag
							})
						})
					}),
					/* @__PURE__ */ jsx(Button, {
						subtle: true,
						onClick: closeHandler,
						children: /* @__PURE__ */ jsx(Icon, { Icon: IoClose })
					})
				] })]
			}),
			mailAction && /* @__PURE__ */ jsxs("div", {
				className: "mb-base border-neutral p-sm rounded border",
				ref: actionRef,
				children: [/* @__PURE__ */ jsxs("div", {
					className: "mb-xs inline-flex w-full justify-between",
					children: [/* @__PURE__ */ jsx("h2", {
						className: "text-md",
						children: mailAction === MailAction.Forward ? "Forward" : "Reply"
					}), /* @__PURE__ */ jsx(Button, {
						className: "ml-xs",
						onClick: () => setMailAction(void 0),
						subtle: true,
						variant: "critical",
						children: /* @__PURE__ */ jsx(Icon, { Icon: IoClose })
					})]
				}), /* @__PURE__ */ jsx(MailMessageForm, {
					mailAction,
					initialValues: {
						body: responseData.body,
						bodyHtml: responseData.bodyHtml,
						fileUrls,
						receiverUserAndGroupIds: responseData.recipients,
						subject: `${responseData.subjectPrefix}: ${subject}`,
						threadId
					},
					onComplete: () => {
						setMailAction(void 0);
						closeHandler?.();
					}
				})]
			}),
			/* @__PURE__ */ jsx(MailMessageThread, {
				beforeMessagesCount: linkedMessages.before,
				afterMessagesCount: linkedMessages.after,
				message: mailMessage,
				threadMessageIds: threadMessagesIds
			})
		] })]
	});
};
export { MailMessageDisplayModal };

//# sourceMappingURL=index.js.map